import { createSvgIcon } from "@mui/material";

const ArrowUpDown = createSvgIcon(
  <path d="M10 8H6L12 2L18 8H14V16H18L12 22L6 16H10V8Z" fill="currentColor" />,
  "ArrowUpDown"
);

export default ArrowUpDown;
